import { render, staticRenderFns } from "./DeleteProjectGroupDialog.vue?vue&type=template&id=4bce5d7c&"
import script from "./DeleteProjectGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteProjectGroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports